var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Avatar, Grid, Typography } from "@mui/material";
import { t } from "i18next";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAlertDetailsURL, JobcardAlertUpsertUrl } from "../../api/url";
import { ChevronDown, GreyPhoneIcon } from "../../assets/images";
import { InputBox, MuiButton, MuiStack } from "../../components";
import { MuiIconButton } from "../../components/atoms/iconButtonComponent";
import { MuiSelectComponent } from "../../components/atoms/muiSelectComponent";
import { LOCAL_STORAGE_KEYS } from "../../constants";
import { showLoader, showNotification } from "../../redux/commonSlice";
import { createAPI, getListAPI } from "../../redux/crudSlice";
import { useAppDispatch } from "../../store/hooks";
import { faintblue, faintGray, gray, mobilenoblack } from "../../theme/palette";
import { GoogleAnlyticsErrorLog } from "../../utils/utils";
import { getLocalStorageItem } from "../../utils/storageHelper";
var initialFValues = {
    repeatReason: "",
    remarks: ""
};
export var AlertDetailsRevisit = function (props) {
    var _previousJobcard$Orga, _previousJobcard$Orga2, _previousJobcard$Orga3, _previousJobcard$Orga4;
    var repeatRevisitReasonList = props.repeatRevisitReasonList, alertId = props.alertId, jobCardId = props.jobCardId, JobcardNo = props.JobcardNo, previousJobcard = props.previousJobcard, toggleDrawer = props.toggleDrawer, repeatRevisitId = props.repeatRevisitId, remark = props.remark, setRepeatRevisitId = props.setRepeatRevisitId, setRemark = props.setRemark;
    var _a = useState(false), isExpand = _a[0], setIsExpand = _a[1];
    var _b = useState(false), isExpandParent = _b[0], setIsExpandParent = _b[1];
    var _c = useState(null), alertDetails = _c[0], setAlertDetails = _c[1];
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var getAlertDetailsById = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, _result$payload2, requestBody, result, _result$payload3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        AlertId: alertId,
                        ParentId: jobCardId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: '',
                            url: getAlertDetailsURL,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success && result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.data) {
                        setAlertDetails(result === null || result === void 0 || (_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.value) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.data);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (alertId) {
            getAlertDetailsById();
        }
    }, [alertId]);
    var onViewJCClick = function (e) {
        toggleDrawer();
        navigate("/jobcard-details/".concat(previousJobcard === null || previousJobcard === void 0 ? void 0 : previousJobcard.id));
        window.location.reload();
    };
    var handleCollapseExpand = function () {
        setIsExpand(!isExpand);
    };
    var handleCollapseExpandParent = function () {
        setIsExpandParent(!isExpandParent);
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        "AlertId": alertId,
                        "ParentId": jobCardId,
                        "ChildAssociations": [],
                        "RepeatRevisitReasonId": repeatRevisitId,
                        "Remarks": remark
                    };
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    dispatch(createAPI({
                        key: "",
                        url: JobcardAlertUpsertUrl,
                        request: request
                    })).then(function () {
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Alert details updated successfully !",
                            type: "success"
                        }));
                    }).catch(function () {
                        var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Alert details did not updated !");
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Alert details did not updated !",
                            type: "error"
                        }));
                    }).finally(function () {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        sx: {
            border: "1px solid ".concat(faintGray),
            borderRadius: "8px"
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12,
        sx: {
            backgroundColor: '#E6F2FF',
            borderRadius: isExpand ? "8px 8px 0px 0px" : "8px"
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        p: '12px 16px 12px 16px'
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 10
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: gray
    }, "Prev. job card")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        color: mobilenoblack
    }, JobcardNo)), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle2",
        color: mobilenoblack
    }, previousJobcard && previousJobcard.EstimateDeliveryDateTime ? moment(previousJobcard.EstimateDeliveryDateTime).format('DD MMM, YYYY') : '-')))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 2,
        sx: {
            textAlign: 'end',
            placeSelf: 'center'
        }
    }, /*#__PURE__*/ React.createElement(MuiIconButton, {
        onClick: function () { return handleCollapseExpand(); }
    }, /*#__PURE__*/ React.createElement(Avatar, {
        variant: "square",
        sx: {
            height: '24px',
            width: '24px'
        },
        src: isExpand ? GreyPhoneIcon : ChevronDown
    })))), isExpand && /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            border: "1px solid ".concat(faintGray)
        }
    })), isExpand && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12,
        sx: {
            backgroundColor: faintblue
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        p: 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle1",
        color: gray
    }, "Dealer information:")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 6,
        md: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        color: mobilenoblack
    }, previousJobcard && previousJobcard.OrganizationName ? previousJobcard.OrganizationName : "-")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 6,
        md: 6,
        sx: {
            textAlign: 'end'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: mobilenoblack
    })), previousJobcard && previousJobcard.OrganizationAddress && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle2",
        color: mobilenoblack
    }, "".concat((_previousJobcard$Orga = previousJobcard.OrganizationAddress.Address1) !== null && _previousJobcard$Orga !== void 0 ? _previousJobcard$Orga : "", " ").concat((_previousJobcard$Orga2 = previousJobcard.OrganizationAddress.CityName) !== null && _previousJobcard$Orga2 !== void 0 ? _previousJobcard$Orga2 : "", " ").concat((_previousJobcard$Orga3 = previousJobcard.OrganizationAddress.StateName) !== null && _previousJobcard$Orga3 !== void 0 ? _previousJobcard$Orga3 : "", " ").concat((_previousJobcard$Orga4 = previousJobcard.OrganizationAddress.Zip) !== null && _previousJobcard$Orga4 !== void 0 ? _previousJobcard$Orga4 : ""))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12,
        pt: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle1",
        color: gray
    }, "Service advisor :")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: mobilenoblack
    }, previousJobcard && previousJobcard.ServiceAdvisorGivenName && previousJobcard.ServiceAdvisorFamilyName ? previousJobcard.ServiceAdvisorGivenName + ' ' + previousJobcard.ServiceAdvisorFamilyName : "-")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12,
        sx: {
            display: 'flex',
            gap: '10px',
            placeItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Avatar, {
        variant: "square",
        sx: {
            height: '16px',
            width: '16px'
        },
        src: GreyPhoneIcon
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: gray
    }, "9987766451"), /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            border: "1px solid ".concat(faintGray),
            height: '16px'
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: gray
    }, "9987766451"))), /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            border: "1px solid ".concat(faintGray)
        }
    })), isExpand && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12,
        sx: {
            backgroundColor: faintblue
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        p: 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle1",
        color: gray
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: mobilenoblack
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 6,
        md: 6
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12,
        pt: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle1",
        color: gray
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: mobilenoblack
    })))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 6,
        md: 6,
        sx: {
            placeContent: 'center',
            textAlign: 'end'
        }
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        variant: "text",
        name: "View JC",
        sx: {
            backgroundColor: faintblue
        },
        onClick: function (e) { return onViewJCClick(e); }
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            border: "1px solid ".concat(faintGray)
        }
    })))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12,
        pt: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        paddingY: 1,
        sx: {
            '&::after': {
                content: '"*"',
                color: 'red',
                marginLeft: '2px'
            }
        }
    }, t("Revisit reason")), /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        id: "revisitReason",
        options: repeatRevisitReasonList !== null && repeatRevisitReasonList !== void 0 ? repeatRevisitReasonList : [],
        fullWidth: true,
        name: "revisitReason",
        displayExpr: "DisplayName",
        valueExpr: "RepeatRevisitReasonId",
        value: repeatRevisitId,
        onChange: function (event) {
            var id = event.target.value ? event.target.value : "";
            setRepeatRevisitId(id);
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12,
        pt: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        paddingY: 1
    }, t("Remarks")), /*#__PURE__*/ React.createElement(InputBox, {
        tabIndex: 1,
        value: remark,
        onChange: function (event) {
            setRemark(event.target.value);
        },
        placeholder: t('Enter Remarks'),
        fullWidth: true,
        size: "small"
        // value={values?.remarks}
        ,
        name: "remarks"
        // onChange={handleInputChange}
        // error={errors?.remarks}
        ,
        sx: {
            "& .MuiInputBase-root.Mui-disabled": {
                backgroundColor: "#ffff",
                borderRadius: '8px'
            }
        },
        id: "remarks"
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12,
        py: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            border: "1px solid ".concat(faintGray)
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        sm: 12,
        sx: {
            textAlign: 'end'
        }
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        variant: "contained",
        size: "medium",
        name: "Save",
        onClick: function (e) { return handleSave(); }
    })));
};
